import React from 'react';

import { Text } from '@chakra-ui/react';

import { createMaterials, updateMaterials } from 'api/materials';

import type { FormType } from '..';

export const materialForm: FormType = {
  createFn: createMaterials,
  updateFn: updateMaterials,
  cancelText: 'Cancelar',
  submitText: 'Salvar Material',
  disableText: 'Excluir Material',
  successText: 'Material salvo com sucesso!',
  fields: [
    [
      {
        name: 'name',
        type: 'text',
        required: true,
        props: {
          placeholder: 'Material biológico',
          label: 'Nome',
        },
      },
    ],
    [
      {
        name: 'packaging',
        type: 'text',
        required: false,
        props: {
          placeholder: 'Acondicionamento',
          label: 'Tipo de Acondicionamento',
        },
      },
      {
        name: 'type',
        type: 'text',
        required: false,
        props: {
          placeholder: 'Tipo',
          label: 'Tipo de Material',
        },
      },
    ],
    [
      {
        name: 'minTemperature',
        type: 'text',
        required: false,
        onChange: (event, setValue, getValues, setError, clearErrors) => {
          const maxTemperature = Number(getValues('maxTemperature'));
          const minTemperature = Number(event.target.value);
          if (maxTemperature < minTemperature) {
            setError('maxTemperature', {
              type: 'min',
              message: 'A temp. max não pode ser menor que a mín.',
            });
            setError('minTemperature', {
              type: 'max',
              message: 'A temp. mín não pode ser maior que a máx.',
            });
          } else {
            clearErrors(['minTemperature', 'maxTemperature']);
          }
        },
        props: {
          viewProps: {
            width: '24%',
          },
          placeholder: '0',
          label: 'Temp. mín',
          RightElement: () => (
            <Text
              variant="mediumRegular"
              color="gray.400">ºC
            </Text>
          ),
        },
      },
      {
        name: 'maxTemperature',
        type: 'text',
        required: false,
        onChange: (event, setValue, getValues, setError, clearErrors) => {
          const minTemperature = Number(getValues('minTemperature'));
          const maxTemperature = Number(event.target.value);
          if (maxTemperature < minTemperature) {
            setError('maxTemperature', {
              type: 'min',
              message: 'A temp. max não pode ser menor que a mín.',
            });
            setError('minTemperature', {
              type: 'max',
              message: 'A temp. mín não pode ser maior que a máx.',
            });
          } else {
            clearErrors(['minTemperature', 'maxTemperature']);
          }
        },
        props: {
          viewProps: {
            width: '24%',
          },
          placeholder: '100',
          label: 'Temp. máx',
          RightElement: () => (
            <Text
              variant="mediumRegular"
              color="gray.400">ºC
            </Text>
          ),
        },
      },
      {
        name: 'ignoreTemperature',
        type: 'checkbox',
        required: false,
        props: {
          viewProps: {
            alignSelf: 'flex-start',
            p: 4,
          },
          children: 'Temperatura não aplicável',
        },
      },
    ],
  ],
};
